export const UPD_DDL = 'update_ddl';
